module.exports = __webpack_public_path__ + "img/toLearn.3abdf0a0.png";